/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Very_GoodInputs */

const cs_enum_very_good = /** @type {(inputs: Enum_Very_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velmi dobrý`)
};

const en_enum_very_good = /** @type {(inputs: Enum_Very_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very good`)
};

/**
* | output |
* | --- |
* | "Very good" |
*
* @param {Enum_Very_GoodInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_very_good = /** @type {((inputs?: Enum_Very_GoodInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Very_GoodInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_very_good(inputs)
	return cs_enum_very_good(inputs)
});